// This file contains all - or at least most - functionality which are used to display modals and various "popups".
import { helpers } from './helpers';

export const modals = {
    ol: $(".page-overlay"),
    overlayCloseCallbacks: [],
    overlayCloseCallbackAdd: (callback) => {
        modals.overlayCloseCallbacks.push(callback);
    },
    init: () => {
        console.debug("modals.js: init");
        if (modals.ol.length) {
            $("body").on("click", ".lightbox-image", helpers.try(modals.toggleLightbox));
            //modals.ol.on("click", ".close-modal", helpers.try(modals.togglePageOverlay));
            $("body").on("click", ".page-overlay .close-modal",  helpers.try(modals.togglePageOverlay));
            modals.ol.on("click", ".lightbox-wrapper .arrow:not(.disabled)", helpers.try(modals.lightboxArrowClick));
            modals.ol.on("click", ".lightbox-wrapper .dot-index div", helpers.try(modals.lightboxDotClick));
            $(document).keydown(helpers.try(modals.keyDownArrowKeys));
            $("body").on("click", ".bottom-modal-campaign .input-button", () => {
                //helpers.try(modals.toggleBottomCampaign);
                $(".bottom-modal-campaign").toggleClass("active");
            }); // BottomCampaign AKA Newsletter modal
            //$("body").on("click", ".bottom-modal-campaign-close", helpers.try(modals.toggleBottomCampaign));
            //$("body").on("click", ".page-overlay", helpers.try(modals.closeBottomCampaignIfOpen));
            $("body").on("click", ".header-select-country", helpers.try(() => {
                modals.showSidebar(".select-country-sidebar");
            }));
            $("body").on("click", ".header-nav-item-my-account", helpers.try(() => {
                modals.showSidebar(".my-account-sidebar");
            }));
            $("body").on("click", ".open-contact-sidebar", helpers.try(() => {
                modals.showSidebar(".contact-sidebar");
            }));
            $("body").on("click", ".open-assembly-service-sidebar", helpers.try(() => {
                modals.showSidebar(".assembly-service-sidebar");
            }));

            $("#contact").on("click", ".contact-form-item-chat a", helpers.try(() => {
                if (!window.fcWidget.isOpen()) {
                    window.fcWidget.open();
                }
            }));

            $("body").on("click", ".open-recycle-sidebar", helpers.try(() => {
                modals.showSidebar(".recycle-sidebar");
            }));


            modals.ol.on("mousedown", helpers.try((e) => {
            //modals.ol.click(helpers.try((e) => {
                if ($(e.target).hasClass("page-overlay") && !modals.ol.find(".not-closeable").length) { // checks if there are any modals that are prohibited from getting closed - like forced VAT popup on load
                    modals.togglePageOverlay();
                }
            }));
        }
        // modals.renderBottomCampaign();
        //$("body").on("click", ".overload-popup-trigger", modals.renderOverloadPopup);
        helpers.swipe.addCallback(document.querySelector('.lightbox-wrapper .large'), {
            right: () => {
                modals.lightboxSwipeRight();
            },
            left: () => {
                modals.lightboxSwipeLeft();
            }
        });
    },
    togglePageOverlay: () => {
        if (modals.ol.hasClass("active")) {
            let closeOverlay = () => {
                modals.ol.removeClass("active");
                $("#instruction-video-modal").remove(); // only used for video popup
                $(".page-overlay > div.active").removeClass("active");
                $(".page-overlay > div").hide();
                $("html, body").css("overflow", "auto");
                $("html").css("cursor", "auto");
            }
            let onAnimationEnd = () => {
                closeOverlay();
                //sidebar[0].removeEventListener("animationend", onAnimationEnd);
            }
            if ($(".modal-sidebar.active").length) {
                const sidebar = $(".modal-sidebar.active");
                sidebar.removeClass("active");
                sidebar.addClass("inactive");
                sidebar[0].addEventListener("animationend", onAnimationEnd, { once: true });
            }
            else {
                closeOverlay();
            }
        }
        else {
            $("html, body").css("overflow", "hidden");
            modals.ol.addClass("active");
        }
    },
    /**
     * @param {boolean} forceActive - If true, the page overlay will be forced to be active. If false, the page overlay will be forced to be inactive. If null, the page overlay will be toggled to the opposite of its current state.
     */
    /*togglePageOverlay: (forceActive = null) => {
        if (forceActive === null) {
            console.log("nulllll");
            forceActive = !modals.ol.hasClass("active");
        }

        if (!forceActive) {
            console.log("stuff");
            let closeOverlay = () => {
                modals.ol.removeClass("active");
                $("#instruction-video-modal").remove(); // only used for video popup
                $(".page-overlay > div.active").removeClass("active");
                $(".page-overlay > div").hide();
                $("html, body").css("overflow", "auto");
                $("html").css("cursor", "auto");

                modals.overlayCloseCallbacks.forEach(callback => {
                    callback();
                });
            }
            let onAnimationEnd = () => {
                closeOverlay();
                //sidebar[0].removeEventListener("animationend", onAnimationEnd);
            }
            if ($(".modal-sidebar.active").length) {
                const sidebar = $(".modal-sidebar.active");
                sidebar.removeClass("active");
                sidebar.addClass("inactive");
                sidebar[0].addEventListener("animationend", onAnimationEnd, { once: true });
            } else {
                closeOverlay();
            }
        } else {
            console.log("no");
            $("html, body").css("overflow", "hidden");
            modals.ol.addClass("active");
        }
    },*/
    renderLoading: () => {
        $(".page-overlay .loading").show();
        modals.togglePageOverlay();
        $("html").css("cursor", "wait");
    },
    toggleLightbox: (e) => {
        const img = $(e.currentTarget);
        const id = img.attr("data-lightbox-id");
        const MobileViewThreshold = 992;
        if (window.innerWidth < MobileViewThreshold) {
            return;
        }
        if (typeof id !== typeof undefined && id !== false) {
            if ($(`.lightbox-wrapper[data-lightbox-id='${id}']`).length) {
                modals.resetLightbox(id);
                modals.populateLightbox(id);
                modals.updateLightboxImage(img);
            }
            else {
                modals.populateLightbox(id);
                modals.updateLightboxImage(img);
            }
            $(".lightbox-wrapper").show();
        }
        modals.togglePageOverlay();
    },
    resetLightbox: (id) => {
        const lb = $(`.lightbox-wrapper[data-lightbox-id='${id}']`);
        lb.find(".thumbnails>img").remove();
        lb.find(".dot-index>div").remove();
    },
    populateLightbox: (id) => {
        const lb = $(".lightbox-wrapper");
        lb.attr("data-lightbox-id", id);
        $(`.lightbox-image[data-lightbox-id='${id}']`).each((i, el) => {
            let img = $(el);
            let src = img.attr("data-lightbox-src") ? img.attr("data-lightbox-src") : img.attr("src");
            if (!$(`.lightbox-wrapper .thumb[src='${src}']`).length) {
                lb.find(".thumbnails").append(`<img class="thumb" src="${src}">`);
                lb.find(".dot-index").append('<div></div>');
            }
        });
        if (lb.find(".thumb").length == 1) {
            lb.find(".arrow").addClass("disabled");
        }
    },
    lightboxArrowClick: (e) => {
        const lb = $(".lightbox-wrapper");
        const index = $(e.currentTarget).hasClass("prev") ? (lb.find(".thumb.active").index() - 1) : (lb.find(".thumb.active").index() + 1);
        if (index < 0) {
            index = 0;
        }
        const img = lb.find(".thumb").eq(index);
        modals.updateLightboxImage(img);
    },
    lightboxDotClick: (e) => {
        const index = $(e.currentTarget).index();
        const img = $(".lightbox-wrapper").find(".thumb").eq(index);
        modals.updateLightboxImage(img);
    },
    lightboxSwipeLeft: () => {
        const lb = $(".lightbox-wrapper");
        let index = lb.find(".thumb.active").index() + 1;
        if (index >= lb.find(".thumb").length) {
            index = 0;
        }
        const img = lb.find(".thumb").eq(index);
        modals.updateLightboxImage(img);
    },
    lightboxSwipeRight: () => {
        const lb = $(".lightbox-wrapper");
        let index = lb.find(".thumb.active").index() - 1;
        if (index > lb.find(".thumb").length) {
            index = 0;
        }
        const img = lb.find(".thumb").eq(index);
        modals.updateLightboxImage(img);
    },
    updateLightboxImage: (img) => {
        const lb = $(".lightbox-wrapper");
        const src = img.attr("data-lightbox-src") ? img.attr("data-lightbox-src") : img.attr("src");
        const thumb = $(`.lightbox-wrapper .thumb[src='${src}']`);
        const index = thumb.index();
        const thumbLen = lb.find(".thumb").length;
        const ap = lb.find(".arrow.prev");
        const an = lb.find(".arrow.next");
        if (index === 0) {
            ap.addClass("disabled");
        }
        else {
            ap.removeClass("disabled")
        }
        if (index === (thumbLen - 1)) {
            an.addClass("disabled");
        }
        else {
            an.removeClass("disabled");
        }
        lb.find(".large").attr("src", src);

        // Get translated text
        let ModalText = "";
        switch (prestashop.urls.base_url) {
            case "https://www.dpj.se/":
                ModalText = `Bild ${(index + 1)} av ${thumbLen}`;
                break;
            case "https://www.dpj-workspace.com/dk/":
                ModalText = `Billede ${(index + 1)} af ${thumbLen}`;
                break;
            case "https://www.dpj-workspace.com/fi/":
                ModalText = `Kuva ${(index + 1)} / ${thumbLen}`;
                break;
            case "https://www.dpj-workspace.com/at/":
                ModalText = `Bild ${(index + 1)} von ${thumbLen}`;
                break;
            case "https://www.dpj-workspace.com/fr/":
                ModalText = `Image ${(index + 1)} sur ${thumbLen}`;
                break;
            case "https://www.dpj-workspace.com/de/":
                ModalText = `Bild ${(index + 1)} von ${thumbLen}`;
                break;
            case "https://www.dpj-workspace.com/nl/":
            case "https://www.dpj-workspace.com/be/":
                ModalText = `Afbeelding ${(index + 1)} van ${thumbLen}`;
                break;
            default:
                ModalText = `Image ${(index + 1)} of ${thumbLen}`;
        }

        lb.find(".text-index").html(ModalText);
        lb.find(".dot-index div").removeClass("active");
        lb.find(".dot-index div").eq(index).addClass("active");
        lb.find(".thumb").removeClass("active");
        thumb.addClass("active");
    },
    renderBottomCampaign: () => { // this function renders a clickable campaign button to the left bottom of the site after some time for desktop users. When clicked an info box pops up right below the button
        if (!helpers.isSmallDevice()) {
            // used to limit the campaign to specific pages. empty bodyClassLimits array to disregard any limits
            let allowdDisplay = false;
            const bodyClassLimits = ['page-index', 'category-id-1008', 'product-id-category-1008'];
            const bodyClassLimitsLength = bodyClassLimits.length;
            for (var i = 0; i < bodyClassLimitsLength; i++) {
                if ($("body").hasClass(bodyClassLimits[i])) {
                    allowdDisplay = true;
                    break;
                } 
            }
            if (bodyClassLimits.length && !allowdDisplay) {
                return;
            }

            const popupDelay = 17000; // in ms. studies have shown that 20s is a good middle ground between annoying and useful
            const suffix = helpers.getCountrySuffix();
            const content = {
                /*at: {
                    btn: 'BEFRISTETES ANGEBOT - KOSTENLOSER VERSAND',
                    icon: '<i class="fas fa-clock"></i>',
                    box: 'Dieses Angebot gilt für Bestellungen über 200 €'
                },
                de: {
                    btn: 'BEFRISTETES ANGEBOT - KOSTENLOSER VERSAND',
                    icon: '<i class="fas fa-clock"></i>',
                    box: 'Dieses Angebot gilt für Bestellungen über 200 €'
                },
                fr: {
                    btn: 'OFFRE LIMITÉE - LIVRAISON GRATUITE',
                    icon: '<i class="fas fa-clock"></i>',
                    box: 'Valable pour toute commande supérieure à 200 €'
                },
                nl: {
                    btn: 'TEMPORARY OFFER - FREE SHIPPING',
                    icon: '<i class="fas fa-clock"></i>',
                    box: 'This offer is applied on orders above 200 €'
                },*/
                /*se: {
                    btn: 'Följ vårt nyhetsbrev',
                    icon: '<i class="fas fa-bell"></i>',
                    box: `               
                    <div class="newsletter-img">
                    </div>
                    <div class="newsletter-text">
                        <svg class="dpj-icon-close bottom-modal-campaign-close" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xml:space="preserve" style="width: 30px;float: right;cursor: pointer;"><g transform="translate(18877.419 20762.419)"><line class="st0" x1="-18859.2" y1="-20756.7" x2="-18871.7" y2="-20744.2"></line><line class="st0" x1="-18871.7" y1="-20756.7" x2="-18859.2" y2="-20744.2"></line></g></svg> 
                        <h3 style="padding-top: 33px;font-size:24px;">Följ vårt nyhetsbrev</h3>
                        <p>Få personliga erbjudanden och tips på snygg design - direkt till mejlkorgen. Vi ser till att du inte missar några bra deals, samtidigt som vi håller dig uppdaterad om ergonomi och kontorstrender. </p>
                        <p style="padding-bottom: 20px;">Skriv upp dig redan idag!</p>
                        <p style="margin: 0px 0px -7px 0px; ">E-post:</p>
                        <script>window.mokiniSettings = {mokini_id: "a290dec2b0e4d94ced08056f704afa313fb3941aa456f2104d3d714ade1173facc859325e39b18b100cc04f0677015a2dc7e"};</script>
                        <script async src='https://assets.mokini.com/mokini.min.js'></script>
                        <div class='mokini-form-contents'>
                        <form class='mokini-embedded-form' method='POST' onsubmit='window.mokini.submitWithCaptcha(this); return false;'>
                        <div class="input-custom" style="margin: 10px 0px;border-radius: 5px;border: 0px;box-shadow: 0 0 6px #d0d0d0;">
                        <input id='customer_email' name='customer[email]' required='required' style='width: 100%; background: #fff; text-align: center;border-radius: 5px;' type='email'>
                        </div>
                        <div class='mokini-honeypot' style='position: absolute; left: -9000px;'>
                        <input aria-hidden='true' id='h_0n3yp07' name='h_0n3yp07' placeholder='Only fill this in if you&rsquo;re a robot.' tabindex='-1' type='text'>
                        </div>
                        <input id='customer_tag' name='customer[tag]' type='hidden' value='newsletter-popup'>
                        <input class="input-button green-checkout-button" name='commit' type='submit' value='Skicka' style="justify-content:center; width:100%;border-radius: 5px;font-size: 15px;">
                        </form>
                        <div class='mokini-embedded-form-success' style='display:none;'>
                        <p>You are now signed up!</p>
                        </div>
                        <div class='mokini-embedded-form-failure' style='display:none;'>
                        <p>Something went wrong, please try again later!</p>
                        </div>
                        </div>
                    </div>`
                },*/
                at: {
                    btn: '15 % Rabattcode',
                    icon: '<i class="fas fa-clock"></i>',
                    box: `Sichern Sie sich mit dem Code <strong>PREMIUM15</strong> jetzt 15 % Rabatt auf ausgewählte <a href="${prestashop.urls.base_url}1008-">Produkte unserer Premium-Aktion</a>.<br>Gültig vom 11. August bis einschließlich 2. November.`
                },
                de: {
                    btn: '15 % Rabattcode',
                    icon: '<i class="fas fa-clock"></i>',
                    box: `Sichern Sie sich mit dem Code <strong>PREMIUM15</strong> jetzt 15 % Rabatt auf ausgewählte <a href="${prestashop.urls.base_url}1008-">Produkte unserer Premium-Aktion</a>.<br>Gültig vom 11. August bis einschließlich 2. November.`
                },
                dk: {
                    btn: 'Rabatkode 15 %',
                    icon: '<i class="fas fa-clock"></i>',
                    box: `Brug koden <strong>PREMIUM15</strong> ved kassen og få <strong>15 %</strong> på <a href="${prestashop.urls.base_url}1008-">produkter i vores premiumkampagne</a>.<br>Gælder fra 11. august til og med 2. november.`
                },
                fi: {
                    btn: 'Alennuskoodi 15 %',
                    icon: '<i class="fas fa-clock"></i>',
                    box: `Käytä kassalla koodia <strong>PREMIUM15</strong> ja saat <strong>15 %</strong> alennusta <a href="${prestashop.urls.base_url}1008-">premium-kampanjamme tuotteista</a>.<br>Tarjous on voimassa 11. elokuuta – 2. marraskuuta.`
                },
                fr: {
                    btn: 'Code de réduction 15 %',
                    icon: '<i class="fas fa-clock"></i>',
                    box: `Utilisez le code <strong>PREMIUM15</strong> lors du paiement et bénéficiez de <strong>15 %</strong> de réduction sur tous les produits de notre <a href="${prestashop.urls.base_url}1008-">campagne premium</a>.<br>Offre valable du 11 août au 2 novembre inclus.`
                },
                nl: {
                    btn: '15% kortingscode',
                    icon: '<i class="fas fa-clock"></i>',
                    box: `Gebruik de code <strong>PREMIUM15</strong> bij het afrekenen en ontvang <strong>15%</strong> korting op <a href="${prestashop.urls.base_url}1008-">producten uit onze premiumcampagne</a>.<br>Geldig van 11 augustus t/m 2 november.`
                },
                be: {
                    btn: '15% kortingscode',
                    icon: '<i class="fas fa-clock"></i>',
                    box: `Gebruik de code <strong>PREMIUM15</strong> bij het afrekenen en ontvang <strong>15%</strong> korting op <a href="${prestashop.urls.base_url}1008-">producten uit onze premiumcampagne</a>.<br>Geldig van 11 augustus t/m 2 november.`
                },
                se: {
                    btn: 'Rabattkod 15 %',
                    icon: '<i class="fas fa-clock"></i>',
                    box: `Använd kod <strong>PREMIUM15</strong> i kassan och få <strong>15 %</strong> på <a href="${prestashop.urls.base_url}1008-premiumkampanj">produkter i vår premiumkampanj</a>.<br>Gäller 11 augusti t.o.m. 2 november.`
                },
            };

            if (!Object.hasOwn(content, suffix)) {
                return;
            }

            $("body").append(`
            <div class="bottom-modal-campaign">
                <button class="input-button">
                    ${content[suffix].icon}
                    <i class="fas fa-times-circle"></i>
                    <div>${content[suffix].btn}</div>
                </button>
                <div class="info modal-campaign-open">${content[suffix].box}</div>
            </div>`);

            // Open automatically after 17 seconds
            let delay = localStorage.getItem('bottom_campaign') ? 0 : popupDelay;
            setTimeout(() => {
                /*if (delay) {
                    $(".bottom-modal-campaign").addClass("active");
                    //$(".bottom-modal-campaign .modal-campaign-open-button").toggleClass("d-none");
                }*/
                $(".bottom-modal-campaign").fadeIn();
                localStorage.setItem('bottom_campaign', 'true');
            }, delay);
        }
    },
    /*toggleBottomCampaign: () => {
        $(".bottom-modal-campaign").toggleClass("active");

        // Some special handling here to support when the modal opened automatically after 17 seconds
        if ($(".bottom-modal-campaign").hasClass("active")) {
            //$(".page-overlay").addClass("active");
            $(".bottom-modal-campaign .modal-campaign-open-button").addClass("d-none");
        }
        else {
            //$(".page-overlay").removeClass("active");
            $(".bottom-modal-campaign .modal-campaign-open-button").removeClass("d-none");
        }
    },*/
    /*closeBottomCampaignIfOpen: () => {
        if ($(".bottom-modal-campaign").hasClass("active")) {
            $(".bottom-modal-campaign").removeClass("active");
            $(".page-overlay").removeClass("active");
            $(".bottom-modal-campaign .modal-campaign-open-button").removeClass("d-none");
        }
    },*/
    showSidebar: (selector) => {
        modals.togglePageOverlay();
        const sidebar = $(selector);
        sidebar.show();
        sidebar.removeClass("inactive");
        sidebar.addClass("active");
    },
    keyDownArrowKeys: (eventObject) => {
        if (eventObject.keyCode == 37) {
            $(".arrow.prev").click();
        }
        if (eventObject.keyCode == 39) {
            $(".arrow.next").click();
        }
        if (eventObject.keyCode == 27) {
            if ($(".lightbox-wrapper").css("display") == "block") {
                $(".lightbox-wrapper .close-modal").click();
            }
        }
    },
}